import { render, staticRenderFns } from "./EditarAtalhos.vue?vue&type=template&id=e2d12e68&scoped=true&lang=pug"
import script from "./EditarAtalhos.vue?vue&type=script&lang=js"
export * from "./EditarAtalhos.vue?vue&type=script&lang=js"
import style0 from "./EditarAtalhos.vue?vue&type=style&index=0&id=e2d12e68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d12e68",
  null
  
)

export default component.exports